import { Component, Listen, Prop, State, h } from '@stencil/core';
import type { labelProviderInterface } from '../../../../../LabelProviderInterface';
import dynamicBannerStore from '../../../conversational-search-banners/dynamic-banner/dynamic-banner-store';

@Component({
  tag: 'uiaas-search-widget-conversational-search-messages-initial-mediator',
  shadow: false,
})
export class ConversationalSearchMessagesInitialMediator {
  @Prop() readonly labelProvider: labelProviderInterface;
  @Prop() readonly searchQuery: string;
  @Prop() readonly acceptanceCallback: (query: string) => void;

  @State() isNewConversation = false;
  @State() conversationStartQuery: string;

  @Listen('conversational-search:user-start-of-conversation', {
    target: 'window',
  })
  userQuestionStatetHandler() {
      this.acceptanceCallback(this.conversationStartQuery);
  }

  @Listen('conversational-search:user-new-conversation', {
    target: 'window',
  })
  userNewConversationHandler() {
      this.isNewConversation = true;
  }

  @Listen('conversational-search:input-action', { target: 'window' })
  handleNewchatQueryFromBanner(e) {
      this.conversationStartQuery = e.detail.query;
  }

  private newConversationTemplate = () => (
    <uiaas-conversational-search-message-new-conversation
      labelProvider={(e, f) => this.labelProvider(e, f)}
      query={this.conversationStartQuery}
    />
  );

  connectedCallback() {
      this.isNewConversation = true;
  }

  async componentDidUpdate() {
      if (!this.conversationStartQuery) {
        this.conversationStartQuery = await dynamicBannerStore.get('question') ?? this.searchQuery;
      }
  }

  render() {
      if (this.isNewConversation) return this.newConversationTemplate();
  }
}
